import { useCallback, useMemo, useState } from "react";
import { Button } from "reactstrap";

import { IndividualPaymentModal } from "./IndividualPaymentModal";
import { formatPaymentLabel } from "../utils/formatters";

interface CellParams {
  data?: any;
  canMakePayment?: boolean;
}

export const PayMilestoneCellRenderer = ({
  data,
  canMakePayment,
}: CellParams) => {
  if (!canMakePayment) {
    return null;
  }

  const [isModalOpen, setIsModalOpen] = useState(false);

  const amount = useMemo(() => {
    // Prefer holdBalance if available; fallback to rate
    const val = Number(data?.holdBalance ?? data?.rate ?? 0);
    return Number.isFinite(val) ? val : 0;
  }, [data]);

  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const label = useMemo(() => {
    return formatPaymentLabel(amount);
  }, [amount]);

  return (
    <>
      <Button
        color="dark"
        size="sm"
        outline
        onClick={handleOpenModal}
        disabled={amount <= 0}
        className="py-0 px-2"
      >
        {label}
      </Button>

      <IndividualPaymentModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        milestone={data}
      />
    </>
  );
};
